import { render, staticRenderFns } from "./updateOrder.vue?vue&type=template&id=76f56ff1&scoped=true"
import script from "./updateOrder.vue?vue&type=script&lang=js"
export * from "./updateOrder.vue?vue&type=script&lang=js"
import style0 from "./updateOrder.vue?vue&type=style&index=0&id=76f56ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f56ff1",
  null
  
)

export default component.exports